import { Field, Formik, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useNavigate, useSearchParams } from "react-router-dom";
import {  useState } from 'react';
import useAxios from '../../hooks/useAxios';
import Constants from '../../Constants';
import { confirm } from '../../utils/swal';
import XLink from '../../components/common/XLink';
import XButton from '../../components/common/XButton';
import {
    inputFieldClasses,
    inputFieldStyleClasses,
    labelStyleClasses,
    errorMessageClasses,
} from '../../components/common/formInputClasses';

const expiredHeadingClasses = 'text-[calc(var(--spacing)*25)] font-bold text-primary mb-0 [text-shadow:3px_5px_2px_color-mix(in_srgb,var(--color-content)_20%,transparent)]';
const expiredParagraphClasses = 'px-4 pt-2.5 pb-5';

const ChangePassword = () => {
    const { postData } = useAxios()
    let [searchParams] = useSearchParams();
    let token = searchParams.get('token');
    let navigate = useNavigate();
    const [isTokenValid, setTokenValid] = useState(true);
    const validationSchema = Yup.object().shape({
        password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long'),
        confirmPassword: Yup.string().required('Confirm password is required').oneOf([Yup.ref('password')], 'Passwords must match')
    })
    const onSubmit = (values) => {
        values.token = token;
        postData(Constants.ApiUrl.auth.resetPassword, values).then((res) => {
            if(res.success){
                confirm({ icon: "success", title: res.message }).then((result) => {
                    if (result.isConfirmed) {
                      navigate('/account/login')
                    }
                  });
            }else{
                setTokenValid(false);
            }
        }).catch(() => {
            setTokenValid(false);
        })
    }
 
    return (
        <>
            {
                isTokenValid ?
                    <div className="content">
                        <h3 className="font-['Open_Sans',serif]! text-content mb-6!">
                            Change Password?
                        </h3>
                        <Formik
                            initialValues={{
                                password: '',
                                confirmPassword: '',
                            }}
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setErrors }) => {
                                onSubmit(values, setErrors)
                            }}
                        >
                            {() => (
                                <Form>
                                    <div className="fields">
                                        <div className="form-group">
                                            <label className={labelStyleClasses}>Password</label>
                                            <div className={inputFieldClasses}>
                                                <Field className={inputFieldStyleClasses} type="password" name="password" placeholder="Enter New Password" />
                                                <ErrorMessage name="password" component="div" className={errorMessageClasses} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className={labelStyleClasses}>Confirm Password</label>
                                            <div className={inputFieldClasses}>
                                                <Field className={inputFieldStyleClasses} type="password" name="confirmPassword" placeholder="Confirm New Password" />
                                                <ErrorMessage name="confirmPassword" component="div" className={errorMessageClasses} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-between items-center'>
                                        <XLink to="/account/login"><i className="fa-solid fa-arrow-left"></i> Back to Login</XLink>
                                        <XButton type="submit">Submit</XButton>
                                    </div>
                                </Form>)}
                        </Formik>
                    </div>
                    : 
                        <div className="container">
                            <div className="row">
                                <div className="inline-block text-center">
                                    <h1 className={expiredHeadingClasses}>Oops, this link is expired</h1>
                                    <p className={expiredParagraphClasses}>This URL is not valid anymore.</p>
                                    <XLink to="/account/login"><i className="fa-solid fa-arrow-left"></i> Back to Login</XLink>
                                </div>
                            </div>
                        </div> 
            }
        </>

    )
}

export default ChangePassword;